import { render, staticRenderFns } from "./user-details-modal.vue?vue&type=template&id=f4889f36&scoped=true&"
import script from "./user-details-modal.vue?vue&type=script&lang=ts&"
export * from "./user-details-modal.vue?vue&type=script&lang=ts&"
import style0 from "./user-details-modal.vue?vue&type=style&index=0&id=f4889f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4889f36",
  null
  
)

export default component.exports